document.addEventListener("DOMContentLoaded", () => {
  const videos = document.querySelectorAll("[data-video-autoplay]");

  videos.forEach((video) => {
    const playPromise = video.play();

    if (playPromise !== undefined) {
      playPromise.catch((err) => {
        console.warn("Autoplay blocked, fallback not working", err);
      });
    }
  });
});
